import { AfterViewInit, Directive, ElementRef, Input, NgModule } from '@angular/core';
import * as Stickyfill from 'stickyfilljs';

@Directive({
  selector: '[appStickyFill]'
})
export class StickyFillDirective implements AfterViewInit {

  @Input('appStickyFill') enabled: boolean;

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    if (this.enabled) {
      Stickyfill.add(this.elementRef.nativeElement);
    }
  }
}
@NgModule({
  declarations: [StickyFillDirective],
  exports: [StickyFillDirective],
})
export class StickyFillModule { }
